export const passwordStrength = {
  getMessage: field => `The password must have at least 1 number`,
  validate: value => {
    var strongRegex = new RegExp("[*0-9]");
    return strongRegex.test(value);
  }
};
